import { Box, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const TypeSelector = ({ isLeaflet, data, setType }) => {
  const { t } = useTranslation();

  return (
    <Box>
      <InputLabel shrink>{t("/editor.gui.marker_type")}</InputLabel>
      <Select
        disabled={isLeaflet}
        value={isLeaflet ? "2D" : data?.marker?.type ?? "3D"}
        onChange={(e) => setType(e.target.value)}
      >
        <MenuItem value={"2D"}>2D</MenuItem>
        {!isLeaflet && <MenuItem value={"3D"}>3D</MenuItem>}
      </Select>
    </Box>
  );
};

export default TypeSelector; 